var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }